import React, { useState } from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './css/cosmos.css';
import 'weather-icons/css/weather-icons.css';

import Navbar from './app_components/Navbar';


const api={
  key:"b30991855ef829a215b3c7c7c53182c7",
  base:"https://api.openweathermap.org/data/2.5/"
}

const App = () =>{
  const [query, setQuery]= useState('');
  const [output, setOutput]=useState({});

  const search = evt => {
    if(evt.key === "Enter"){
      fetch(`${api.base}weather?q=${query}&units=metric&APPID=${api.key}`)
        .then(res => res.json())
        .then(result => {
          setOutput(result);
          setQuery('');
          console.log(result);
        });
    }
  }

  const dateDisplay = (d) => {
    let months=["January","February","March","April","May","June","July","August","September","October","November","December"];
    let days=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

    let day=days[d.getDay()];
    let date=d.getDate();
    let month=months[d.getMonth()];
    let year=d.getFullYear();

    return `${day} ${date} ${month} ${year}`; 
  }

 function getIcon(id){
    switch(true)
      {
        case id >= 200 && id <= 232:
          return(
            <h5 className="py-3">
              <i className="wi wi-thunderstorm display-6"></i>
            </h5>
          );
        case id >= 300 && id <= 321:
          return(
            <h5 className="py-3">
              <i className="wi wi-sleet display-6"></i>
            </h5>
          );
        case id >= 500 && id <= 531:
          return(
            <h5 className="py-2">
              <i className="wi wi-rain-mix display-6"></i>
            </h5>
          );
        case id >= 600 && id <= 622:
          return(
            <h5 className="py-2">
              <i className="wi wi-snowflake-cold display-6"></i>
            </h5>
          );
        case id >= 701 && id <= 781:
          return(
            <h5 className="py-2">
              <i className="wi wi-fog display-6"></i>
            </h5>
          );
        case id === 800:
          return(
            <h5 className="py-2">
              <i className="wi wi-day-sunny display-6"></i>
            </h5>
          ); 
        case id >= 801 && id <= 804:
          return(
            <h5 className="py-2">
              <i className="wi wi-cloudy display-6"></i>
            </h5>
          );
        default:
          return(
            <h5 className="py-2">
              <i className="wi wi-cloudy-windy display-6"></i>
            </h5>
          )
      }
  }

  const minmaxTemp = (min,max)=>{
    if(min && max){
        return(
            <h5>
                <span className="px-4">
                    {Math.round(min)}&deg;C
                </span>    
                <span className="px-4">
                    {Math.round(max)}&deg;C
                </span>
            </h5>
        );
    }else{
        return null;
      }
    }
      
      return(
        <div className="App">
          <Navbar/>
          <main>
            <div className="row">
              <div className="col-12"></div>
              <div className="col-12"></div>
              <div className="col-12 search-box">
                    <input 
                      className="search-bar"
                      type="text"
                      placeholder="Search . . ."
                      autoComplete="off"
                      onChange={e => setQuery(e.target.value)}
                      value={query}
                      onKeyPress={search} />  
              </div>
            </div>

            <div className="row">
              <div className="col-3"></div>
              <div className="col-6">
                <div className="card-container">
                  {typeof output.main != "undefined" ?(
                    <div className="card card-body">
                    <br />
                    
                      <h4>{output.name}, {output.sys.country}</h4>
                
                      <p className="day">{dateDisplay(new Date())}</p>

                      {getIcon(output.weather[0].id)}

                      <h4>{output.weather[0].description}</h4>

                      <p className="py-2">{Math.round(output.main.temp)}&deg;C</p>
                

                      {/**Show maximum and minimum temperature */}

                      {minmaxTemp(output.main.temp_min,output.main.temp_max)}   

                      <div className="row pt-4">
                        <span>
                            <p className="extra px-4"><i className="wi wi-humidity display-7 px-2"></i>{output.main.humidity}%</p>
                        </span>
                        <span>
                          <p className="extra px-4"><i className="wi wi-barometer display-7 px-2"></i>{output.main.pressure}pa</p>
                        </span>
                      </div> 
                     
                      <br />
                    </div>
                  ): [
                    output.cod === '404' ? (
                      <div className="card card-body">City not found</div>
                    ) : ('') 
                  ]}

                </div>
              </div>
              <div className="col-3"></div>
            </div>
          </main>
          <br />
          <br />
          <div className="Footer">
            <footer className="footer">
                <p className="footer-text">Designed &amp; &copy; - 2021 Gayathiri-M </p>
            </footer>
          </div>
        </div>
      );
}

export default App;